import { Component } from "react";
import { withRouter } from 'react-router-dom';
import { getEnv, loadedInIframe } from "../../helpers/GeneralHelper";
import { connect } from "react-redux";
import {hasGtmEnabled, isGdprRegion, isInHub} from "../../helpers/AppHelper";

class CookieScripts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            appWasLoaded: false,
            appLoadError: null,
            scriptsLoaded: false
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.appWasLoaded !== prevState.appWasLoaded) {
            return ({appWasLoaded: nextProps.appWasLoaded})
        }
        if (nextProps.appLoadError !== prevState.appLoadError) {
            return ({appLoadError: nextProps.appLoadError})
        }

        return null;
    }

    componentDidMount() {
        if (this.shouldWeLoadCookieScripts() === true) {
            if (loadedInIframe() || isInHub() === false) {
                // we let the product or the website handle the cookie stuff
            } else {
                this.insertScriptInHead();
            }
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) { }
    insertScriptInHead = () => {
        const script = document.createElement("script"), env = getEnv();
        script.src = this.getScriptSrc(env);
        script.async = true;
        document.head.appendChild(script);

        this.setState({scriptsLoaded: true});
    };
    getScriptSrc = (env) => {
        let scriptName = 'eu_shared.js', scriptSrc = '';
        if (isGdprRegion() === false) {
            scriptName = 'non_' + scriptName;
        }


        switch(env) {
            case 'test':
            case 'development':
                scriptSrc = 'https://d3tvj3lw2y3r4c.cloudfront.net/webpage/test/js/cookies/' + scriptName;
                // scriptSrc = '/development_' + scriptName;
                break;
            default:
                scriptSrc = 'https://d3tvj3lw2y3r4c.cloudfront.net/webpage/prod3/js/cookies/' + scriptName;
        }

        return scriptSrc;
    };
    shouldWeLoadCookieScripts = () => {
        return (
            this.state.appWasLoaded === true &&
            typeof window.jQuery !== 'undefined' &&
            this.state.scriptsLoaded === false &&
            hasGtmEnabled() === true
        );
    };
    render() {
        return null;
    }
}

const mapStateToProps = (state) => {
    return {
        appWasLoaded: state.app.appLoaded,
        appLoadError: state.app.error
    }
};

export default withRouter(connect(mapStateToProps, null)(CookieScripts));
